export const LINE_COLORS = ['lime', 'red', 'aqua', 'magenta', 'yellow', 'deepskyblue', 'tomato',
    'springgreen', 'cyan', 'deeppink', 'darkorange', 'aquamarine'];

export const currentDateWithoutTimezone = new Date().toISOString().slice(0,10);;

export const keywordHelpText = "Tag yourself so your line can be included in searches";

export const locationHelpText = "Tell us about where you were born and the places you've lived. Enter any of the following: full street address; city; state; country; or zip code.";